import React from 'react';

const SuperAdminSidebar = ({ isOpen, onClose, userInfo, onNavigate, activePage }) => {
    const userInitial = userInfo ? (userInfo.fullName || userInfo.full_name || userInfo.name || 'A').charAt(0).toUpperCase() : 'A';
    const userName = userInfo ? (userInfo.fullName || userInfo.full_name || userInfo.name || 'Admin') : 'Admin';

    const handleLogout = () => {
        sessionStorage.clear();
        localStorage.clear();
        if (onNavigate) {
            onNavigate('hostel-login');
        }
    };

    const MenuItem = ({ emoji, label, route, isActive }) => (
        <div
            className={`menu-item ${isActive ? 'menu-item-active' : ''}`}
            onClick={() => {
                if (route && onNavigate) {
                    onNavigate(route);
                }
                if (window.innerWidth <= 1024) {
                    onClose();
                }
            }}
        >
            <span className="menu-icon">{emoji}</span>
            <span className="menu-label">{label}</span>
            <div className="menu-glow"></div>
        </div>
    );

    return (
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
            <div className="sidebar-header">
                <div className="sidebar-top">
                    {/* Close button for mobile */}
                    <div style={{ flex: 1 }}></div>
                    <button onClick={onClose} className="close-btn" style={{ display: window.innerWidth > 1024 ? 'none' : 'flex' }}>✕</button>
                </div>
                <div className="user-info-sidebar">
                    <div className="user-avatar-sidebar">{userInitial}</div>
                    <div className="user-details-sidebar">
                        <div className="user-name-sidebar">{userName}</div>
                        <div className="user-role-sidebar">System Administrator</div>
                    </div>
                </div>
            </div>

            <div className="sidebar-nav">
                <div className="nav-section">
                    <div className="nav-label">Main Menu</div>
                    <MenuItem
                        emoji="🏠"
                        label="Dashboard"
                        route="hostel-superadmin-dashboard"
                        isActive={activePage === 'hostel-superadmin-dashboard'}
                    />
                    <MenuItem
                        emoji="🏢"
                        label="Manage Hostels"
                        route="hostel-superadmin-manage-hostel"
                        isActive={activePage === 'hostel-superadmin-manage-hostel'}
                    />
                    <MenuItem
                        emoji="👨‍💼"
                        label="Manage Admins"
                        route="hostel-superadmin-manage-admin"
                        isActive={activePage === 'hostel-superadmin-manage-admin'}
                    />
                    <MenuItem
                        emoji="👥"
                        label="Manage Students"
                        route="hostel-superadmin-manage-students"
                        isActive={activePage === 'hostel-superadmin-manage-students'}
                    />
                    <MenuItem
                        emoji="📋"
                        label="Audit Logs"
                        route="hostel-superadmin-audit-logs"
                        isActive={activePage === 'hostel-superadmin-audit-logs'}
                    />
                </div>

                <div className="nav-section">
                    <div className="nav-label">System</div>
                    <MenuItem
                        emoji="💾"
                        label="Backup & Restore"
                        route="hostel-superadmin-backup"
                        isActive={activePage === 'hostel-superadmin-backup'}
                    />
                </div>

                <div className="nav-section">
                    <div className="nav-label">Operations</div>
                    <MenuItem
                        emoji="✅"
                        label="Check In/Out"
                        route="hostel-superadmin-manage-checkin"
                        isActive={activePage === 'hostel-superadmin-manage-checkin'}
                    />
                    <MenuItem
                        emoji="📋"
                        label="Applications"
                        route="hostel-superadmin-manage-application"
                        isActive={activePage === 'hostel-superadmin-manage-application'}
                    />
                    <MenuItem
                        emoji="🛠️"
                        label="Requests & Issues"
                        route="hostel-superadmin-manage-requests"
                        isActive={activePage === 'hostel-superadmin-manage-requests'}
                    />
                    <MenuItem
                        emoji="💬"
                        label="Grievances"
                        route="hostel-superadmin-manage-grievance"
                        isActive={activePage === 'hostel-superadmin-manage-grievance'}
                    />
                    <MenuItem
                        emoji="📦"
                        label="Requisitions"
                        route="hostel-superadmin-manage-requisition"
                        isActive={activePage === 'hostel-superadmin-manage-requisition'}
                    />
                    <MenuItem
                        emoji="🧺"
                        label="Laundry"
                        route="hostel-superadmin-manage-laundry"
                        isActive={activePage === 'hostel-superadmin-manage-laundry'}
                    />
                </div>
            </div>

            <div className="logout-section">
                <button onClick={handleLogout} className="logout-btn">🚪 Logout</button>
            </div>
        </div>
    );
};

export default SuperAdminSidebar;
